import {Injectable} from '@angular/core';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';

export abstract class LoginStorageService {

  abstract saveLogin(jwt: any, user: any);

  abstract getUser(): any;

  abstract getJwt(): any;

  abstract clear();

}

@Injectable()
export class LoginSessionStorageService implements LoginStorageService {

  constructor(private sessionStorageService: SessionStorageService) {
  }

  saveLogin(jwt: any, user: any) {
    this.sessionStorageService.store('jwt', jwt);
    this.sessionStorageService.store('user', user);
  }

  getUser(): any {
    return this.sessionStorageService.retrieve('user');
  }

  getJwt(): any {
    return this.sessionStorageService.retrieve('jwt');

  }

  clear() {
    this.sessionStorageService.clear('jwt');
    this.sessionStorageService.clear('user');
  }
}

@Injectable()
export class LoginLocalStorageService implements LoginStorageService {
  constructor(private localStorageService: LocalStorageService) {
  }

  saveLogin(jwt: any, user: any) {
    this.localStorageService.store('jwt', jwt);
    this.localStorageService.store('user', user);
  }

  getUser(): any {
    return this.localStorageService.retrieve('user');
  }

  getJwt(): any {
    return this.localStorageService.retrieve('jwt');
  }

  clear() {
    this.localStorageService.clear('jwt');
    this.localStorageService.clear('user');
  }

}
